export class SearchGlobally {
    static readonly type = '[Global Search] Search';

    constructor(public payload: { term: string }) {}
}

export class ClearGlobalSearch {
    static readonly type = '[Global Search] Clear search';
}

export class RememberSearchTerm {
    static readonly type = '[Global Search] Remember search term';

    constructor(public payload: { term: string }) {}
}

export class ClearRecentSearchTerms {
    static readonly type = '[Global Search] Clear recent search terms';
}
